module.exports = __webpack_public_path__ + "img/Boss-2.0a6e43a5.gif";